<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Empower Your Educational Platform with Minglepay’s Payment Gateway</div>
            <div class="banner_tips mt-40 fw-300">Focus on inspiring learners while we streamline your payment processes. Our all-in-one payment solution for educational platforms is designed to prioritize ease, efficiency, and growth.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">What We Offer</div>
                <div class="title_tag color6">Top Features for Educational Platforms</div>
            </div>
          <div class="py-20" v-for="item in list1" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center" :class="[item.id%2==0?'order-2':'']">
                    <div class="page_title ">
                        <div class="h-10px mb-20 bg_3 title_line" ></div>
                        <div class="title_name color2 text-l">{{ item.title }}</div>
                        <div class="title_tag color6 text-l">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">How Does a Payment Gateway Work for Education?</div>
                <div class="title_tag color1">Minglepay’s payment gateway acts as a digital conductor, securely guiding financial data between learners, your platform, and banks. Powered by AI and machine-learning, our system delivers fast, secure, and efficient payment processing tailored for the education</div>
            </div>
        </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">What is Open Banking?</div>
                        <div class="title_tag color6 text-l">Open banking enables traditional banks to share data securely with licensed fintech providers like Minglepay. This streamlines transactions, making payments faster and more reliable. Our ecosystem connects leading banks across the UK and EU, ensuring effortless </div>
                    </div>
                </div>
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t49.png" alt="">
                  </div>
                </div>
                
              </div>
          </div>
          <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>
                
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are transactions processed?" name="1">
                            <div class="coll_item">Funds are available in your account within minutes, thanks to our instant transaction technology.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Minglepay secure for marketplaces?" name="2">
                           <div class="coll_item">Yes, our platform uses advanced encryption and AI-powered fraud detection to ensure every transaction is protected.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I integrate Minglepay with my existing platform?" name="3">
                           <div class="coll_item">Absolutely! Our streamlined APIs make integration quick and easy, getting your marketplace up and running in no time.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t50.png" alt="">
                  </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Supercharge Your Marketplace</div>
                        <div class="title_tag color6 text-l">Experience the efficiency of instant payments, seamless integrations, and powerful analytics. With Minglepay, your marketplace can focus on growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from '../../assets/image/t45.png'
import icon2 from '../../assets/image/t46.png'
import icon3 from '../../assets/image/t47.png'
import icon4 from '../../assets/image/t48.png'

import icon5 from '../../assets/image/t26.png'
import icon6 from '../../assets/image/t27.png'
import icon7 from '../../assets/image/t28.png'

import icon8 from '../../assets/image/t29.png'
import icon9 from '../../assets/image/t30.png'
import icon10 from '../../assets/image/t31.png'
export default {
    data(){
        return{
            list1:[
                {title:'Scalable Payment Plans',msg:"Whether you’re a small academy or a global e-learning platform, our flexible plans adapt to your needs, supporting your growth every step of the way.",img:icon1,id:1},
                {title:'Secure Transaction Processing',msg:"Our payment gateway ensures safe, reliable transfers of financial data between learners, your platform, and banks.",img:icon2,id:2},
                {title:'AI-Powered Insights',msg:"Leverage advanced analytics to understand learner behavior and optimize your platform’s performance.",img:icon3,id:3},
                {title:'Global Banking Integration',msg:"Connect effortlessly with major banks across the UK, EU, and beyond for smooth, secure transactions.",img:icon4,id:4},
            ],
            list2:[
                {title:"Customer Behavior Insights",msg:"Understand your users with detailed segmentation and predictive algorithms.",img:icon5,id:1},
                {title:"Real-Time Data",msg:"Monitor transactions and trends to make informed business decisions.",img:icon6,id:2},
                {title:"Actionable Forecasting",msg:"Anticipate market demands with AI-driven forecasting tools.",img:icon7,id:3},
            
            ],
            list3:[
                {title:"Connected Banking Network",msg:"Integrate with major banks across the UK, EU, and beyond for effortless payments.",img:icon8,id:1},
                {title:"AI-Enhanced Solutions",msg:"Leverage machine-learning technology for smarter, more secure transaction processing.",img:icon9,id:2},
                {title:"Scalable Growth Plans",msg:"From small marketplaces to global platforms, our flexible solutions grow with you.",img:icon10,id:3},
            
            ],
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg4.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}

</style>